/**重置message，防止重复点击重复弹出message弹框 */
import { Message } from 'element-ui';

let messageInstance = null;
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
};


['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 105, // 设置偏移量为100px
        showClose: true //是否显示关闭按钮
      }
    }
    else {
      options.offset = 105;// 设置偏移量为100px
      options.showClose = true; //是否显示关闭按钮
    }
    options.type = type
    return resetMessage(options)
  }
})

export const message = resetMessage


// WEBPACK FOOTER //
// ./src/utils/message.js